import { injectOperatorApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/operator.service';
import { baseApi } from '@service/base.api';

export const operatorApi = injectOperatorApi(baseApi);

export const {
  useGetOperatorsPaginatedQuery,
  useGetOperatorQuery,
  useCreateOperatorMutation,
  useUpdateOperatorMutation,
  useDeleteOperatorMutation,
} = operatorApi;
